import { useState } from "react";
import { ExportDialog } from "./ExportDialog.js";
import { Box, Typography } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFileExport } from "@fortawesome/free-solid-svg-icons";
import useStyles from '../../../styles/global-mui.js';

export const ExportButton = ({ targetUrl }) => {

  const [open, setOpen] = useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const getURL = () => {
    let urlLocation = undefined;
    // On récupère l'url de live
    if (process.env.NODE_ENV === 'development') {
      urlLocation = 'http://localhost:3006';
    } else {
      urlLocation = process.env.REACT_APP_LIVE_CLIENT_URL;
    }

    let url = `${urlLocation}/${targetUrl}`

    return url;
  };

  const classes = useStyles();

  return (
    <>
      <Box className='actionButtonIcon' sx={{
        border: '2px solid var(--color-blue-secondary)',
        color: 'var(--color-blue-secondary)',
        padding: '0.4rem',
        width: 'fit-content',
        justifyItems: 'center',
        justifySelf: 'center',
        cursor : 'pointer'
      }} onClick={handleClickOpen}>
          <Typography className={classes.responsiveText}>Export</Typography>
          <FontAwesomeIcon icon={faFileExport} />
      </Box>
      
      
      <ExportDialog
        open={open}
        onClose={handleClose}
        url={getURL()}
      />
    </>
  );
};